// Additional steps that make our Vue app run in the browser
import makeStore from 'app/store'
import makeRouter from 'app/router'
import routes from 'app/routes'
import dashboard from 'app/plugins/dashboard'
import SiteLink from 'app/components-wa/nav/SiteLink'
import VueGtag from 'vue-gtag'
import { sync } from 'vuex-router-sync'
import { WEB_AWESOME_LAYOUT } from 'app/router/layouts'
import ModalTermsAcceptanceReminder from 'app/views/accounts/AccountView/Settings/ModalTermsAcceptanceReminder'
import { mapActions, mapGetters } from 'vuex'

import ApolloClient from 'apollo-boost'
import VueApollo from 'vue-apollo'

import InstantSearch from 'vue-instantsearch'

export default (vueInstance) => {
  const store = makeStore(vueInstance)
  const router = makeRouter(vueInstance, routes)

  sync(store, router)

  vueInstance.use(InstantSearch)

  vueInstance.use(
    VueGtag,
    {
      config: { id: FONTAWESOME.GOOGLE_TRACKING_ID },
      disableScriptLoad: true,
      enabled: FONTAWESOME.GOOGLE_TRACKING_ENABLED === 'yes'
    },
    router
  )

  vueInstance.use(dashboard)

  vueInstance.component('site-link', SiteLink(vueInstance, { defaultLayout: WEB_AWESOME_LAYOUT }))

  if (FONTAWESOME.ENV === 'production') {
    vueInstance.config.devtools = false
    vueInstance.config.silent = true
  } else {
    vueInstance.config.performance = true
  }

  const apolloClient = new ApolloClient({
    uri: FONTAWESOME.API_URL
  })

  const apolloProvider = new VueApollo({
    defaultClient: apolloClient
  })

  const App = vueInstance.extend({
    name: 'App',
    components: {
      ModalTermsAcceptanceReminder
    },
    template: `
      <div id="vue-container" @drop.prevent @dragover.prevent>
        <router-view></router-view>
        <dashboard />
        <modal-terms-acceptance-reminder
          :is-showing="shouldShowTermsReminder"
        />
      </div>
    `,
    router,
    apolloProvider,
    store,
    computed: {
      ...mapGetters('termsAcceptance', ['needsTermsAcceptance']),
      isInTermsExclusionRoute() {
        const path = (this.$route && this.$route.path) || ''
        const blocked = ['/start/confirm', '/account/set-password', '/account/personal-info']

        return blocked.some((blockedPath) => path.startsWith(blockedPath))
      },

      accountPresenceKey() {
        const account = this.$account

        if (!account || account.id == null) {
          return 'no-account'
        }

        const accepted = account.termsAcceptedAt || 'null'
        return `${account.id}-${accepted}`
      },

      shouldShowTermsReminder() {
        const account = this.$account || {}
        const hasAccount = account && account.id != null

        if (!hasAccount) {
          return false
        }

        if (this.isInTermsExclusionRoute) {
          return false
        }

        return this.needsTermsAcceptance
      }
    },
    watch: {
      accountPresenceKey: {
        immediate: true,
        handler() {
          this.evaluateTermsAcceptance({ account: this.$account })
        }
      }
    },
    methods: {
      ...mapActions('termsAcceptance', { evaluateTermsAcceptance: 'evaluate' })
    }
  })

  const app = new App()

  router.onReady(() => {
    app.$mount('#vue-container')
  })
}
